import React, { ReactNode, useMemo } from 'react';
import {
  FeatureFlagsContext,
  PageLoader,
  TokenProperties,
  useClientTokenManager,
} from '@cko/dashboard-shared';
import { LDContext } from 'launchdarkly-js-client-sdk';
import { useLaunchDarkly } from '../../integrations/LaunchDarkly/launchDarkly';

type LdCustomContext = {
  clientId?: string;
  subEntityId?: string;
  permissions: string[];
  userRoles: string[];
};
export const getLDContextForUser = (
  tokenProperties: TokenProperties | undefined,
): LDContext | undefined => {
  if (!tokenProperties) {
    return undefined;
  }

  const {
    userId: key,
    sub: email,
    permissions,
    userRoles,
    clientId,
    subEntityId,
  } = tokenProperties;

  const customContext: LdCustomContext = {
    permissions,
    userRoles,
    clientId,
    subEntityId,
  };

  const context: LDContext = {
    custom: customContext,
    email,
    key,
  };

  return context;
};

export const FeatureFlagConfigurationManager = ({ children }: { children: ReactNode }) => {
  const { tokenProperties } = useClientTokenManager();
  const userContext: LDContext | undefined = useMemo(
    () => getLDContextForUser(tokenProperties),
    [tokenProperties],
  );
  const { loaded, identified, flags } = useLaunchDarkly(userContext);

  const getFeatureFlag = (flag: string) => {
    return flags[flag];
  };

  const getMultiVariateFlag = (flag: string) => {
    return flags[flag];
  };

  return (
    <FeatureFlagsContext.Provider
      value={{
        getFeatureFlag,
        getMultiVariateFlag,
        isUserIdentified: identified,
        // no-op as we don't want MFEs to update this and will remove from context.
        setIsUserIdentified: () => {},
      }}
    >
      {loaded ? children : <PageLoader />}
    </FeatureFlagsContext.Provider>
  );
};
